var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-discuss-speech__item",
      class: { "yxtbiz-discuss-speech__item--replay": _vm.data.replyCount },
    },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-discuss-speech__avatar" },
        [
          _c("yxt-avatar", {
            class: { hand: !_vm.isPreview },
            attrs: {
              imgUrl: _vm.data.creatorImageUrl,
              username: _vm.data.creatorName,
              size: "48px",
            },
            on: { click: _vm.openUserInfo },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yxtbiz-discuss-speech__content" },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-discuss-speech__user-info" },
            [
              _c(
                "yxtf-tooltip",
                {
                  attrs: {
                    placement: "top",
                    effect: "dark",
                    "open-filter": "",
                    content: _vm.data.creatorName,
                  },
                },
                [
                  _c("yxtbiz-user-name", {
                    staticClass: "ellipsis",
                    attrs: { name: _vm.data.creatorName },
                  }),
                ],
                1
              ),
              _c(
                "yxtf-tooltip",
                {
                  attrs: {
                    placement: "top",
                    effect: "dark",
                    "open-filter": "",
                    content: _vm.data.creatorDeptName,
                  },
                },
                [
                  _c("yxtbiz-dept-name", {
                    staticClass: "ellipsis",
                    attrs: { name: _vm.data.creatorDeptName },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "yxtbiz-discuss-speech__text" },
            [
              _c(
                "row-clamp",
                {
                  staticClass: "color-gray-9",
                  attrs: { "max-lines": 2, autoresize: "" },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.data.filtered) + "\n        "
                  ),
                  _vm.isSub
                    ? [
                        _c(
                          "span",
                          { attrs: { slot: "before" }, slot: "before" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(this.$t("pc_biz_lbl_reply")) +
                                " "
                            ),
                            _vm.data.parentCreatorName
                              ? _c(
                                  "span",
                                  { staticClass: "color-gray-10" },
                                  [
                                    _c("yxtbiz-user-name", {
                                      staticClass: "user-name ellipsis",
                                      attrs: {
                                        name: _vm.data.parentCreatorName,
                                      },
                                    }),
                                    _vm._v(":\n            "),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c("yxtbiz-attachment-list", {
            attrs: { list: _vm.data.attachmentList },
          }),
          _c("div", { staticClass: "yxtbiz-discuss-speech__comment-info" }, [
            _c(
              "div",
              { staticClass: "yxtbiz-discuss-speech__comment-info-left" },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.friendlyDateBeforeFilter(_vm.data.createTime))
                  ),
                ]),
                _vm.data.replyCount
                  ? _c(
                      "span",
                      {
                        staticClass: "yxtbiz-discuss-speech__comment-info-view",
                        on: { click: _vm.toggleReplay },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.replayVisible
                                ? "pc_biz_discuss_hide_replay_with_count"
                                : "pc_biz_discuss_view_replay_with_count",
                              [_vm.data.replyCount]
                            )
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-discuss-speech__comment-info-right" },
              [
                !_vm.isPreview && !_vm.data.mine && _vm.enableComplain
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "mr24 flex-align-center hover-primary-6 hand",
                        on: { click: _vm.addCommentComplain },
                      },
                      [
                        _c("yxt-svg", {
                          staticClass: "mr2 hover-primary-6",
                          attrs: {
                            height: "16px",
                            "icon-class": "tip-offs",
                            width: "16px",
                          },
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_biz_complain_title").d("举报")) +
                            "\n        "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isPreview && _vm.data.mine
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "mr24 flex-align-center hover-primary-6 hand",
                        on: {
                          click: function ($event) {
                            return _vm.deleteReply(_vm.data)
                          },
                        },
                      },
                      [
                        _c("yxt-svg", {
                          staticClass: "mr2 hover-primary-6",
                          attrs: {
                            "remote-url": _vm.svgUrl,
                            height: "16px",
                            "icon-class": "delete",
                            width: "16px",
                          },
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_common_cate_delete").d("删除")) +
                            "\n        "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "span",
                  {
                    staticClass: "mr24 flex-align-center",
                    class: { "hand hover-primary-6": !_vm.isPreview },
                    on: { click: _vm.replayComment },
                  },
                  [
                    !_vm.isPreview
                      ? [
                          _c("yxt-svg", {
                            staticClass: "mr2 hover-primary-6",
                            attrs: {
                              "remote-url": _vm.svgUrl,
                              height: "16px",
                              "icon-class": "icon-comment",
                              width: "16px",
                            },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_lbl_reply").d("回复")) +
                              "\n          "
                          ),
                        ]
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("pc_bbs_lbl_replayName", [
                                _vm.data.replyCount,
                              ])
                            )
                          ),
                        ]),
                  ],
                  2
                ),
                _c(
                  "span",
                  {
                    staticClass: "flex-align-center",
                    on: {
                      click: function ($event) {
                        return _vm.praises(_vm.data)
                      },
                    },
                  },
                  [
                    !_vm.isPreview
                      ? [
                          _c("yxtf-action-icon", {
                            staticClass: "hand",
                            attrs: {
                              size: "32px",
                              light: "",
                              actived: !!_vm.data.userPraised,
                              readonly: !!_vm.data.userPraised,
                            },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.data.praiseCount) +
                              "\n          "
                          ),
                        ]
                      : _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("pc_biz_lbl_praise_count", [
                                  _vm.data.praiseCount,
                                ])
                              ) +
                              "\n          "
                          ),
                        ]),
                  ],
                  2
                ),
              ]
            ),
          ]),
          _c("transition", { attrs: { name: "yxt-fade-in-linear" } }, [
            _vm.replayCommentVisible
              ? _c(
                  "div",
                  { staticClass: "yxtbiz-discuss-speech__replay__area" },
                  [
                    _c("yxt-input", {
                      attrs: {
                        placeholder:
                          _vm.$t("pc_biz_lbl_reply").d("回复") +
                          _vm.data.creatorName,
                        maxlength: "2000",
                        minlength: "5",
                        rows: "2",
                        "show-word-limit": "",
                        type: "textarea",
                      },
                      model: {
                        value: _vm.replayContent,
                        callback: function ($$v) {
                          _vm.replayContent = $$v
                        },
                        expression: "replayContent",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "yxtbiz-discuss-speech__replay__area__action",
                      },
                      [
                        _c(
                          "div",
                          [
                            _vm.allowAnonymous
                              ? _c(
                                  "yxt-checkbox",
                                  {
                                    attrs: {
                                      "false-label": 0,
                                      "true-label": 1,
                                    },
                                    model: {
                                      value: _vm.replayAnonymous,
                                      callback: function ($$v) {
                                        _vm.replayAnonymous = $$v
                                      },
                                      expression: "replayAnonymous",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$t("pc_biz_bbs_lbl_anonymous")
                                          .d("匿名")
                                      ) + "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "yxt-button",
                              { on: { click: _vm.closeReplayComment } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$t("pc_biz_common_cancel_mini")
                                      .d("取消")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "yxt-button",
                              {
                                attrs: {
                                  loading: _vm.replayLoading,
                                  disabled: _vm.replayContent.length < 5,
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.submitReplay(_vm.data)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("pc_biz_complain_submit").d("提交")
                                  ) + "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("transition", { attrs: { name: "yxt-fade-in-linear" } }, [
            _vm.data.replyCount
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.replayVisible,
                        expression: "replayVisible",
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "yxtbiz-discuss-speech__replay",
                  },
                  [
                    _vm._l(_vm.replayList, function (replay) {
                      return _c(
                        "Speech",
                        _vm._b(
                          {
                            key: replay.id,
                            attrs: {
                              ccConfig: _vm.ccConfig,
                              data: replay,
                              orderby: _vm.orderby,
                              "is-sub": "",
                            },
                            on: {
                              "on-delete": _vm.onSpeechDelete,
                              "on-replay": _vm.onSpeechReplay,
                              "get-parent-replay": _vm.refresh,
                            },
                          },
                          "Speech",
                          _vm.$props,
                          false
                        )
                      )
                    }),
                    _c("yxtf-pagination", {
                      staticClass: "mt12 layout-flex layout-justify-end",
                      attrs: {
                        "current-page": _vm.currentPage,
                        "page-size": _vm.pageSize,
                        "page-sizes": [10, 20, 30, 40],
                        total: _vm.totalCount,
                        layout: "total, prev, pager, next",
                        "simple-total": "",
                      },
                      on: { "current-change": _vm.handleCurrentChange },
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c("yxtbiz-complain", {
        ref: "complain",
        attrs: { target: _vm.complainTarget },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }